var _defs, _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #233c6a;\r\n      }\r\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 38.1,
    cy: 38.4,
    r: 36
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.1,31.2H20.1c-1.8,0-3.2-1.8-3.2-4h0c0-2.2,1.5-4,3.2-4h37.1c1.8,0,3.2,1.8,3.2,4h0c0,2.2-1.5,4-3.3,4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.1,43.9H20.1c-1.8,0-3.2-1.8-3.2-4h0c0-2.2,1.5-4,3.2-4h37.1c1.8,0,3.2,1.8,3.2,4h0c0,2.2-1.5,4-3.3,4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.1,56.6H20.1c-1.8,0-3.2-1.8-3.2-4h0c0-2.2,1.5-4,3.2-4h37.1c1.8,0,3.2,1.8,3.2,4h0c0,2.2-1.5,4-3.3,4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.20bca66fd88b27776ce9d4b382916764.svg";
export { ForwardRef as ReactComponent };